// Small display helpers shared across Dashboard sub-components.

export function MiniRow({ label, value, pos }) {
  return (
    <div className="flex justify-between">
      <span className="text-[#59605C]">{label}</span>
      <span className={pos ? "text-[#3B5B3E]" : "text-[#59605C]"}>{value}</span>
    </div>
  );
}
